<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="12" viewBox="0 0 11 12" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.59099 1.20053L1.06066 0.670204L0 1.73086L0.53033 2.26119L4.37868 6.10954L0.749409 9.73881L0.219078 10.2691L1.27974 11.3298L1.81007 10.7995L5.43934 7.1702L9.2877 11.0186L10.3484 9.9579L6.5 6.10954L10.5674 2.0421L9.50678 0.981444L5.43934 5.04888L1.59099 1.20053Z" fill="#232D33"/>
    </svg>
</template>